type CloudGlossaryEntry = {
  title: string;
  season: string;
  body: string;
};

const CLOUD_GLOSSARY: Record<string, CloudGlossaryEntry> = {
  "わた雲": {
    title: "わた雲（積雲）",
    season: "春から夏へ、日差しが強くなるころ",
    body: "晴れた日に地面があたためられると生まれやすい雲です。朝は小さくても、昼に向かって少しずつ大きくなることがあります。もくもく育つ姿に、あたたかい季節の空の動きを感じられます。",
  },
  "うろこ雲": {
    title: "うろこ雲（巻積雲）",
    season: "秋の気配を感じる空",
    body: "空の高いところに、小さな雲がたくさん並ぶ雲です。秋によく目につくため、昔から「秋の空」を感じさせる雲として親しまれています。夏の名残があるころに見つけると、空が少しずつ次の季節へ移っているのを感じられます。",
  },
  "ひつじ雲": {
    title: "ひつじ雲（高積雲）",
    season: "夏の終わりから秋にかけて",
    body: "ふっくらした雲が、羊の群れのように並びます。夏の終わりから秋にかけて目につくことが多く、少し涼しくなってきた空を感じさせます。うろこ雲より一つひとつが大きく見えるのも特徴です。",
  },
  "入道雲": {
    title: "入道雲（積乱雲）",
    season: "盛夏の強い日差しのころ",
    body: "強い日差しで地面があたためられる夏に、大きく育ちやすい雲です。真っ白な雲が空高く立ち上がる姿は、夏らしい風景のひとつです。急な雨や雷につながることもあるので、大きく育ってきたら空の変化にも気をつけます。",
  },
  "すじ雲": {
    title: "すじ雲（巻雲）",
    season: "季節の変わり目にも目につく高い雲",
    body: "空のとても高いところに、白い筋を引いたように現れる雲です。上空の強い風に流されて、羽や刷毛で描いたような形になります。澄んだ空にすじ雲が広がると、季節がゆっくり動いているような空の表情を楽しめます。",
  },
  "うす雲": {
    title: "うす雲（巻層雲）",
    season: "春や秋、天気が移り変わるころにも",
    body: "空の高いところを、白いベールのように薄く覆う雲です。太陽や月のまわりに光の輪が見えることもあります。晴れた空から少しずつ雲が増えてくるときに現れ、季節の変わり目らしい静かな空を見せてくれます。",
  },
  "おぼろ雲": {
    title: "おぼろ雲（高層雲）",
    season: "春のやわらかな空にも似合う雲",
    body: "空を広く覆い、太陽がすりガラス越しのようにぼんやり見える雲です。春には、霞んだ空やおぼろ月と重なってやわらかな景色をつくることがあります。雲がだんだん厚くなると、雨へ向かう空の変化が感じられることもあります。",
  },
  "あま雲": {
    title: "あま雲（乱層雲）",
    season: "梅雨や秋雨など、しっとりした季節に",
    body: "空を灰色に広く覆い、長く続く雨を降らせることの多い雲です。梅雨や秋雨のころには、景色全体をしっとり落ち着いた色に変えます。雨音や草木の濡れ方まで含めて、季節を感じさせる雲です。",
  },
  "うね雲": {
    title: "うね雲（層積雲）",
    season: "秋から冬の空でもよく目につく雲",
    body: "低い空に、大きな雲のかたまりが波のように広がります。日差しが弱くなる秋から冬には、雲のすき間から光が差す景色もよく似合います。重たく見えても雨にならないことも多く、季節の光の変化を感じやすい雲です。",
  },
  "きり雲": {
    title: "きり雲（層雲）",
    season: "冷えた朝や、湿り気の多い季節に",
    body: "地面に近い低いところを、霧のように一面に覆う雲です。朝の冷え込みや湿った空気でできやすく、山や丘では雲の中に入ったように見えることもあります。春や秋の朝など、空気の冷たさや湿り気を肌で感じる景色によく現れます。",
  },
  "ひこうき雲": {
    title: "ひこうき雲",
    season: "空の高いところの冷たさを感じる雲",
    body: "飛行機の排気にふくまれる水蒸気などが、冷たい上空で小さな氷の粒になってできる雲です。すぐ消える日もあれば、長く残って少しずつ広がる日もあります。長く残るひこうき雲を見ると、目には見えない上空の湿り気や、季節ごとの空気の違いまで感じることができます。",
  },
};

const ALIASES: Array<[RegExp, string]> = [
  [/飛行機雲|ひこうき雲|contrail/i, "ひこうき雲"],
  [/巻積雲|cirrocumulus/i, "うろこ雲"],
  [/高積雲|altocumulus/i, "ひつじ雲"],
  [/巻層雲|cirrostratus/i, "うす雲"],
  [/高層雲|altostratus/i, "おぼろ雲"],
  [/積乱雲|cumulonimbus/i, "入道雲"],
  [/乱層雲|nimbostratus/i, "あま雲"],
  [/層積雲|stratocumulus/i, "うね雲"],
  [/巻雲|cirrus/i, "すじ雲"],
  [/積雲|cumulus/i, "わた雲"],
  [/層雲|stratus/i, "きり雲"],
];

function glossaryKey(label: string): string | null {
  const normalized = label.trim();
  if (normalized in CLOUD_GLOSSARY) return normalized;
  for (const [pattern, key] of ALIASES) {
    if (pattern.test(normalized)) return key;
  }
  return Object.keys(CLOUD_GLOSSARY).find((key) => normalized.includes(key)) ?? null;
}

function installGlossaryStyles(): void {
  const style = document.createElement("style");
  style.textContent = `
    .cloud-tags span[data-cloud-glossary] {
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      transition: transform .12s ease, box-shadow .12s ease;
    }
    .cloud-tags span[data-cloud-glossary]:active { transform: scale(.97); }
    .cloud-tags span[data-cloud-glossary]:focus-visible {
      outline: 2px solid var(--sky-dark, #1985a5);
      outline-offset: 3px;
    }
    .cloud-glossary-overlay {
      position: fixed;
      z-index: 160;
      inset: 0;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 18px;
      background: rgba(12,35,42,.42);
    }
    .cloud-glossary-sheet {
      width: min(100%, 520px);
      max-height: min(72dvh, 560px);
      overflow-y: auto;
      border: 1px solid rgba(36,91,105,.14);
      border-radius: 26px;
      padding: 10px 22px 26px;
      background: #f9fdfd;
      box-shadow: 0 22px 70px rgba(8,34,42,.25);
      color: #183039;
    }
    .cloud-glossary-handle { width: 42px; height: 4px; margin: 0 auto 14px; border-radius: 999px; background: #c9dadd; }
    .cloud-glossary-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }
    .cloud-glossary-head h2 { margin: 0; font-size: 1.2rem; line-height: 1.45; }
    .cloud-glossary-close { flex: 0 0 auto; width: 36px; height: 36px; border: 0; border-radius: 50%; background: #e6f0f2; color: #315e68; font-size: 1.35rem; line-height: 1; cursor: pointer; }
    .cloud-glossary-season { margin: 12px 0 8px; color: #1985a5; font-size: .78rem; font-weight: 800; letter-spacing: .02em; }
    .cloud-glossary-body { margin: 0; color: #405f68; font-size: .96rem; line-height: 1.9; }
  `;
  document.head.appendChild(style);
}

function enhanceCloudTags(): void {
  document.querySelectorAll<HTMLElement>(".cloud-tags span").forEach((tag) => {
    if (!glossaryKey(tag.textContent ?? "")) return;
    tag.dataset.cloudGlossary = "1";
    tag.setAttribute("role", "button");
    tag.setAttribute("tabindex", "0");
    tag.setAttribute("aria-label", `${tag.textContent?.trim() ?? "雲"}の説明を見る`);
  });
}

function closeGlossary(): void {
  document.querySelector(".cloud-glossary-overlay")?.remove();
}

function openGlossary(label: string): void {
  const key = glossaryKey(label);
  if (!key) return;
  const entry = CLOUD_GLOSSARY[key];
  closeGlossary();

  const overlay = document.createElement("div");
  overlay.className = "cloud-glossary-overlay";
  overlay.setAttribute("role", "presentation");

  const sheet = document.createElement("section");
  sheet.className = "cloud-glossary-sheet";
  sheet.setAttribute("role", "dialog");
  sheet.setAttribute("aria-modal", "true");
  sheet.setAttribute("aria-label", entry.title);

  const handle = document.createElement("div");
  handle.className = "cloud-glossary-handle";
  handle.setAttribute("aria-hidden", "true");

  const head = document.createElement("div");
  head.className = "cloud-glossary-head";
  const heading = document.createElement("h2");
  heading.textContent = entry.title;
  const closeButton = document.createElement("button");
  closeButton.type = "button";
  closeButton.className = "cloud-glossary-close";
  closeButton.dataset.cloudGlossaryClose = "1";
  closeButton.setAttribute("aria-label", "閉じる");
  closeButton.textContent = "×";
  head.appendChild(heading);
  head.appendChild(closeButton);

  const season = document.createElement("p");
  season.className = "cloud-glossary-season";
  season.textContent = entry.season;
  const body = document.createElement("p");
  body.className = "cloud-glossary-body";
  body.textContent = entry.body;

  sheet.appendChild(handle);
  sheet.appendChild(head);
  sheet.appendChild(season);
  sheet.appendChild(body);
  overlay.appendChild(sheet);
  document.body.appendChild(overlay);
  closeButton.focus();
}

function handleGlossaryClick(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  if (target.closest("[data-cloud-glossary-close]")) {
    closeGlossary();
    return;
  }
  const overlay = target.closest(".cloud-glossary-overlay");
  if (overlay && !target.closest(".cloud-glossary-sheet")) {
    closeGlossary();
    return;
  }
  const tag = target.closest<HTMLElement>(".cloud-tags span[data-cloud-glossary]");
  if (tag) openGlossary(tag.textContent ?? "");
}

function handleGlossaryKeydown(event: KeyboardEvent): void {
  if (event.key === "Escape") {
    closeGlossary();
    return;
  }
  if (event.key !== "Enter" && event.key !== " ") return;
  const target = event.target as HTMLElement;
  const tag = target.closest<HTMLElement>(".cloud-tags span[data-cloud-glossary]");
  if (!tag) return;
  event.preventDefault();
  openGlossary(tag.textContent ?? "");
}

installGlossaryStyles();
document.addEventListener("click", handleGlossaryClick);
document.addEventListener("keydown", handleGlossaryKeydown);
new MutationObserver(enhanceCloudTags).observe(document.documentElement, { childList: true, subtree: true });
queueMicrotask(enhanceCloudTags);
